var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReinvite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/user-add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 10.4998C12.3012 10.4998 14.1667 8.63436 14.1667 6.33317C14.1667 4.03198 12.3012 2.1665 10 2.1665C7.69885 2.1665 5.83337 4.03198 5.83337 6.33317C5.83337 8.63436 7.69885 10.4998 10 10.4998Z",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.84167 18.8333C2.84167 15.6083 6.05001 13 10 13C10.8 13 11.575 13.1083 12.3 13.3083",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.3333 15.5003C18.3333 15.767 18.3 16.0253 18.2333 16.2753C18.1583 16.6087 18.025 16.9337 17.85 17.217C17.275 18.1837 16.2166 18.8337 15 18.8337C14.1416 18.8337 13.3666 18.5086 12.7833 17.9753C12.5333 17.7586 12.3166 17.5003 12.1499 17.217C11.8416 16.717 11.6666 16.1253 11.6666 15.5003C11.6666 14.6003 12.025 13.7753 12.6083 13.1753C13.2166 12.5503 14.0666 12.167 15 12.167C15.9833 12.167 16.875 12.592 17.475 13.2753C18.0083 13.867 18.3333 14.6503 18.3333 15.5003Z",
    stroke: "white",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.2416 15.4834H13.7583",
    stroke: "white",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15 14.2666V16.7583",
    stroke: "white",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReinvite);
export default __webpack_public_path__ + "static/media/reinvite.abc66332b9fc5a616d63d9d070b3a4a2.svg";
export { ForwardRef as ReactComponent };